import { useEffect } from 'react'
import PullToRefresh from "pulltorefreshjs";

let pullToRefreshEnabled = true;

export const disablePullToRefresh = () => {
    pullToRefreshEnabled = false;
};

export const enablePullToRefresh = () => {
    pullToRefreshEnabled = true;
};

export function usePullToRefresh() {
    useEffect(() => {
        PullToRefresh.init({
            shouldPullToRefresh: () => {
                const activeModal = document.querySelector(".menu-hider.menu-active");
                if(activeModal || !pullToRefreshEnabled) return false;
                
                // only allow when scrolled all the way up
                return window.scrollY === 0 || document.documentElement.scrollTop === 0;
            },
            mainElement: "body",  // or a specific container selector
            onRefresh() {
                return new Promise<void>((resolve) => {
                    window.location.reload();
                    resolve();
                });
            },
            instructionsPullToRefresh: "Pull down to refresh",
            instructionsReleaseToRefresh: "Release to refresh",
            instructionsRefreshing: "Refreshing..."
        });

        return () => PullToRefresh.destroyAll();
    }, []);
}
